import React from "react";
import { TodoContext } from "../TodoContext";
import './PreloadLists.css';
import { FormattedMessage } from 'react-intl';

function PreloadLists() {

    const {
        setOpenModalList,
    } = React.useContext(TodoContext)

    const onCancel = () => {
        setOpenModalList(false);
    }

    return (
        <div className="preload--lists">
            <h2><FormattedMessage id="lists.h2" defaultMessage="Lists to preload"/></h2>
            <button onClick={preloadCamping} className="list--button"><FormattedMessage id="lists.btn1" defaultMessage="Camping"/></button>
            <button onClick={preloadBeachDay} className="list--button"><FormattedMessage id="lists.btn2" defaultMessage="Beach day"/></button>
            <button onClick={preloadRiverDay} className="list--button"><FormattedMessage id="lists.btn3" defaultMessage="River day"/></button>
            <div className="TodoForm-buttonContainer">
                <button
                type="button"
                className="TodoForm-button TodoForm-button--cancel"
                onClick={onCancel}
                >
                <FormattedMessage id="form.cancel" defaultMessage="Cancel"/>
                </button>
            </div>
        </div>
    );
}

function preloadCamping() {
    const list = '{"completed":false,"text":"Toalla","date":""},{"completed":false,"text":"Repelete para mosquitos","date":""},{"completed":false,"text":"Bloqueador solar","date":""},{"completed":false,"text":"Ropa ligera","date":""},{"completed":false,"text":"Traje de baño","date":""},{"completed":false,"text":"Calzado cómodo","date":""},{"completed":false,"text":"Lentes de sol","date":""},{"completed":false,"text":"Gorra","date":""},{"completed":false,"text":"Meriendas","date":""},{"completed":false,"text":"Jabón","date":""}';
    if (localStorage.TODOS_V1.length === 2) {
        // empty list
        localStorage.TODOS_V1 = '['+list+']';
    } else {
        // list with elements
        localStorage.TODOS_V1 = localStorage.TODOS_V1.substring(0, localStorage.TODOS_V1.length-1) + ','+list+']';
    }
    window.dispatchEvent( new KeyboardEvent("keydown", { altKey: false, code: "Escape", ctrlKey: false, isComposing: false, key: "Escape", location: 0, metaKey: false, repeat: false, shiftKey: false, which: 27, charCode: 0, keyCode: 27, }) );
}

function preloadBeachDay() {
    const list = '{"completed":false,"text":"Toalla","date":""},{"completed":false,"text":"Repelete para mosquitos","date":""},{"completed":false,"text":"Bloqueador solar","date":""},{"completed":false,"text":"Calzado deportivo y ropa ligera para caminar","date":""},{"completed":false,"text":"Traje de baño","date":""},{"completed":false,"text":"Lentes de sol","date":""},{"completed":false,"text":"Gorra o sombrero","date":""},{"completed":false,"text":"Merienda y termo de agua","date":""}';
    if (localStorage.TODOS_V1.length === 2) {
        // empty list
        localStorage.TODOS_V1 = '['+list+']';
    } else {
        // list with elements
        localStorage.TODOS_V1 = localStorage.TODOS_V1.substring(0, localStorage.TODOS_V1.length-1) + ','+list+']';
    }
    window.dispatchEvent( new KeyboardEvent("keydown", { altKey: false, code: "Escape", ctrlKey: false, isComposing: false, key: "Escape", location: 0, metaKey: false, repeat: false, shiftKey: false, which: 27, charCode: 0, keyCode: 27, }) );
}

function preloadRiverDay() {
    const list = '{"completed":false,"text":"Toalla","date":""},{"completed":false,"text":"Bloqueador solar","date":""},{"completed":false,"text":"Calzado cómodo","date":""},{"completed":false,"text":"Traje de baño","date":""},{"completed":false,"text":"Lentes de sol","date":""},{"completed":false,"text":"Merienda y termo de agua","date":""},{"completed":false,"text":"Segundo cambio de ropa","date":""}';
    if (localStorage.TODOS_V1.length === 2) {
        // empty list
        localStorage.TODOS_V1 = '['+list+']';
    } else {
        // list with elements
        localStorage.TODOS_V1 = localStorage.TODOS_V1.substring(0, localStorage.TODOS_V1.length-1) + ','+list+']';
    }
    window.dispatchEvent( new KeyboardEvent("keydown", { altKey: false, code: "Escape", ctrlKey: false, isComposing: false, key: "Escape", location: 0, metaKey: false, repeat: false, shiftKey: false, which: 27, charCode: 0, keyCode: 27, }) );
}

export { PreloadLists };